import { useRoutes } from 'react-router-dom'
import publicRoute from './routes'

const AuthRoute = () => {
  return useRoutes(publicRoute)
}

export default AuthRoute
